import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.request.link');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-request-link',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.request.link/view.scss */
:host {
  --teal-900: #115e59;
  --teal-600: #0f766e;
  --teal-400: #0f766e;
  --teal-200: #5eead4;
  --teal-100: #ccfbf1;
  --teal-50: #ecfdf5;
  --blue-50: #E6F1FB;
  --blue-800: #0C447C;
  --blue-border: #B5D4F4;
  --green-50: #EAF3DE;
  --green-600: #3B6D11;
  --green-border: #C0DD97;
  --amber-50: #FAEEDA;
  --amber-600: #854F0B;
  --page-bg: #f6f8fb;
  --panel-bg: #ffffff;
  --bg-secondary: #f8fafc;
  --text-primary: #111827;
  --text-secondary: #5b6472;
  --text-tertiary: #8a94a6;
  --border: #e5e7eb;
  --border-soft: #edf0f3;
  display: block;
  min-height: 100%;
  background: var(--page-bg);
}

button {
  font: inherit;
}

.request-page {
  min-height: 100%;
  background: var(--page-bg);
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
}

.hero-banner {
  padding: 28px 32px 0;
  border-bottom: 0.5px solid var(--teal-600);
  background: var(--teal-600);
  color: #ffffff;
}

.hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 26px;
}

.hero-copy {
  min-width: 0;
}

.hero-eyebrow {
  color: var(--teal-100);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  text-transform: uppercase;
}

.hero-copy h1 {
  margin: 4px 0 0;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
}

.hero-copy p {
  margin: 7px 0 0;
  color: var(--teal-100);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.hero-action {
  min-height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  border: 0.5px solid rgba(255, 255, 255, 0.28);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.hero-action.solid {
  border-color: #ffffff;
  background: #ffffff;
  color: var(--teal-600);
}

.info-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 0.5px solid rgba(255, 255, 255, 0.22);
}

.info-cell {
  min-height: 108px;
  padding: 18px 24px;
  border-right: 0.5px solid rgba(255, 255, 255, 0.18);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.info-cell:last-child {
  border-right: 0;
}

.info-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--teal-100);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.info-eyebrow i {
  color: var(--teal-100);
  font-size: 11px;
}

.info-value {
  margin-top: 8px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.1;
}

.info-helper {
  margin-top: 7px;
  color: var(--teal-100);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
}

.request-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  background: var(--page-bg);
}

.request-column {
  min-width: 0;
  padding: 20px;
  border-right: 0.5px solid var(--border);
}

.request-column:last-child {
  border-right: 0;
}

.panel {
  border: 0.5px solid var(--border);
  border-radius: 12px;
  background: var(--panel-bg);
  overflow: hidden;
}

.panel + .panel {
  margin-top: 14px;
}

.panel-head {
  min-height: 58px;
  padding: 14px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 0.5px solid var(--border-soft);
}

.panel-head.compact {
  min-height: 52px;
}

.section-eyebrow {
  display: block;
  color: var(--teal-600);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.panel-head h2 {
  margin: 4px 0 0;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
}

.subtle-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.link-box {
  min-height: 72px;
  padding: 14px;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) 32px;
  align-items: center;
  gap: 12px;
}

.link-icon,
.copy-icon-btn,
.guide-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.link-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--teal-50);
  color: var(--teal-600);
  font-size: 13px;
}

.link-box code {
  min-width: 0;
  overflow: hidden;
  color: var(--text-primary);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-icon-btn {
  width: 32px;
  height: 32px;
  border: 0.5px solid var(--teal-400);
  border-radius: 8px;
  background: var(--teal-400);
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
}

.message-card {
  padding: 16px 14px;
  display: grid;
  gap: 10px;
}

.message-card p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.55;
}

.message-card .link-text {
  overflow: hidden;
  color: var(--teal-900);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.guide-list {
  display: flex;
  flex-direction: column;
}

.guide-row {
  min-height: 52px;
  padding: 12px 14px;
  border-bottom: 0.5px solid var(--border-soft);
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  color: var(--text-primary);
}

.guide-row:last-child {
  border-bottom: 0;
}

.guide-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
  font-size: 12px;
}

.guide-row:nth-child(1) .guide-icon {
  background: var(--blue-50);
  color: var(--blue-800);
}

.guide-row:nth-child(2) .guide-icon,
.guide-row:nth-child(5) .guide-icon {
  background: var(--teal-50);
  color: var(--teal-600);
}

.guide-row:nth-child(3) .guide-icon {
  background: var(--green-50);
  color: var(--green-600);
}

.guide-row:nth-child(4) .guide-icon {
  background: var(--amber-50);
  color: var(--amber-600);
}

.guide-row span:last-child {
  min-width: 0;
  overflow: hidden;
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 980px) {
  .request-body {
    grid-template-columns: 1fr;
  }
  .request-column {
    border-right: 0;
    border-bottom: 0.5px solid var(--border);
  }
  .request-column:last-child {
    border-bottom: 0;
  }
}
@media (max-width: 860px) {
  .hero-banner {
    padding: 24px 18px 0;
  }
  .hero-top {
    flex-direction: column;
    padding-bottom: 20px;
  }
  .hero-actions,
  .hero-action {
    width: 100%;
  }
  .info-strip {
    grid-template-columns: 1fr;
  }
  .info-cell,
  .info-cell:last-child {
    border-right: 0;
  }
  .info-cell:nth-child(n+2) {
    border-top: 0.5px solid rgba(255, 255, 255, 0.18);
  }
  .request-column {
    padding: 16px;
  }
}
@media (max-width: 560px) {
  .link-box {
    grid-template-columns: 32px minmax(0, 1fr);
  }
  .copy-icon-btn {
    grid-column: 2;
    justify-self: flex-start;
  }
}`],
})
export class PageRequestLinkComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public baseUrl: string = '';
    public copied: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.baseUrl = `${window.location.origin}/access`;
        await this.service.render();
    }

    public async copyLink() {
        try {
            await navigator.clipboard.writeText(this.baseUrl);
            this.copied = true;
            await this.service.render();
            setTimeout(async () => {
                this.copied = false;
                await this.service.render();
            }, 1600);
        } catch { }
    }
}

export default PageRequestLinkComponent;